module.exports = __webpack_public_path__ + "static/media/active_choice.6868f964.svg";